import React, { memo } from 'react'
import Typography from 'transfix-ui/core/Typography'
import { makeStyles } from 'transfix-ui/core/styles'
import ChecklistIllustration from 'apps/fleet-planner/components/illustrations/ChecklistIllustration.svg'
import { TEST_IDS } from '../../constants'

const useShipmentsNeedingAttentionEmptyStyles = makeStyles(theme => ({
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    padding: `${theme.spacing(6)} ${theme.spacing(2)}`,
  },
}))

export interface IShipmentsNeedingAttentionEmptyProps {}

const ShipmentsNeedingAttentionEmpty = memo<IShipmentsNeedingAttentionEmptyProps>(() => {
  const classes = useShipmentsNeedingAttentionEmptyStyles()
  return (
    <div className={classes.emptyState} data-test={TEST_IDS.emptyState}>
      <div>
        <img src={ChecklistIllustration} alt='ChecklistIllustration' />
      </div>
      <Typography variant='subtitle1' color='textSecondary' component='div'>
        You&apos;re all caught up!
      </Typography>
      <Typography variant='subtitle2' color='textSecondary' component='div'>
        Loads that need your attention will appear here.
      </Typography>
    </div>
  )
})

export default ShipmentsNeedingAttentionEmpty
